import * as utils from '../utils.js';

export function initCulture() {

	var Page = Barba.BaseView.extend({

		namespace: 'page-culture',

		onEnter: function() {

			//console.log('Init Culture');
			
			this.DOM = {};
		 	this.pageSy = 0;
			document.querySelector('body > header').classList.add('white');

			//Players
			this.DOM.players = this.container.querySelectorAll('.player');
			if (this.DOM.players) {
				this.DOM.players.forEach((item) => {
					let player = new Plyr(item);
	      });
			}

			this.DOM.swipers = this.container.querySelectorAll('.moment__slider');
			if (this.DOM.swipers) {
				this.DOM.swipers.forEach((item) => {
					//console.log(item);
					let swiper = new Swiper(item.querySelector('.swiper-container'), {
						pagination: {
						    el: item.querySelector('.swiper-pagination'),
						    type: 'bullets',
								clickable: true,
						  },
					});
	      });
			}

			//Scroll CULTURE
			this.titleY = [];
			this.lerpFactor = [0.12, 0.22, 0.15, 0.1, 0.5, 0.24, 0.13, 0.3];
			window.addEventListener('scroll', this.onPageScroll);

			this.DOM.pageTitle = this.container.querySelector('h1');
			this.pageTitleChars = new SplitText(this.DOM.pageTitle, {type:"chars"});

			this.pageTitleChars.chars.forEach((chars, index) => {
				this.titleY.push(0);
			})

			let pageTitleTL = new TimelineMax({paused: true});
			pageTitleTL.to(this.DOM.pageTitle, 1, {opacity:0.05, overwrite: "all", ease: Power0.easeNone});

			// Render Page
			this.pageRender = () => {

				this.pageTitleChars.chars.forEach((chars, index) => {
					this.titleY[index] = Math.round(utils.lerp(this.titleY[index], this.pageSy, this.lerpFactor[index]));
					TweenMax.set(this.pageTitleChars.chars[index], {y:this.titleY[index]});
				})

				let norm = utils.clamp(utils.normalize(this.pageSy, 0, window.innerHeight * 0.8), 0, 1);
				pageTitleTL.progress(norm);

			}

      TweenMax.ticker.addEventListener("tick", this.pageRender, this, true, 1);

		},

		onLeave: function() {

			document.querySelector('body > header').classList.remove('white');
			window.removeEventListener('scroll', this.onPageScroll);
			TweenMax.ticker.removeEventListener("tick", this.pageRender, this, true, 1);

		}

	});
	
	Page.onPageScroll = (e) => {
		Page.pageSy = window.pageYOffset || document.documentElement.scrollTop;
	}

	Page.init();

}
